import configuration from '../../envConfig';
import { getInternalResource } from "../../shared/helper/requests";
import { Utf8ArrayToStr, dataURIToBlob, cdvMimeType } from "../../shared/helper/impressao";
import { getUrlVars } from '../../shared/helper/utilitarioUrl';

if (window.cordova_iab) {
    window.cordova_iab.postMessage(JSON.stringify({close: true}));
} else if (window._cordovaNative && configuration.baseUrl !== process.env.REACT_APP__BASE_URL_APP) {
    window.location.href = process.env.REACT_APP__BASE_URL_APP;
}

export const platform = {
    name: "web",
    isWeb: true,
    isCordova: false,
    barraBrasilOffset: '41px'
}

export const getPlatformName = () => {
    return "web";
}

export const reviewDialog = () => {}

export const openStoreScreen = () => {}

export const checkGovBrInstalado = callback => {
    callback(false);
}

export const openGovBr = callback => {
    callback(false);
}

export const openMarketplace = callback => {
    callback(false);
}

export const criarDownloadPdfImpl = (data, fileName) => {
    try {
        var decodedString = Utf8ArrayToStr(new Uint8Array(data));
        var obj = JSON.parse(decodedString);
        if ('result' in obj) {
            return obj.result;
        }
        if ('mensagem' in obj) {
            return obj.mensagem;
        }
        if ('message' in obj) {
            return obj.message;
        }
    } catch (e) {
        var blob = new Blob([data], {
            type: "application/pdf"
        });
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);

        a.style = "display: none";
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        return false;
    }
}

export const downloadArquivosImpl = (data, fileName) => {
    try {
        let nameParts = fileName.split('.');
        let extension = null;
        if (nameParts.length > 1) {
            extension = nameParts[nameParts.length-1].toLowerCase();
        }
        var blob = dataURIToBlob("data:application/json;base64," + data, cdvMimeType(extension));
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = objectUrl;
        a.download = fileName;
        a.click();
    } catch (e) {
        return false;
    }
}

export const closeBrowserTab = () => {}

export const openLoginPage = () => {
    
    console.debug('Abrindo página de login');

    let urlLoginPrefix = configuration.urlLogin;
    let clientId = configuration.clientId;
    let nonce = Math.random() * 13;
    let state = Math.random() * 7;

    let scopes = "openid+email+profile+govbr_confiabilidades_idtoken+poav1_createPoaAccessHistory_agent+poav1_retrievePowersOfAttorneyByAgentAccountIdAndGrantorAccountIdAndClientIdAndIsActive_agent";
    let responseType = "code";
    let page = getUrlVars()['page'];
    let redirectUri = encodeURIComponent(configuration.baseUrlWeb + (page ? `?page=${page}` : ''));
    let loginUrl = `${urlLoginPrefix}authorize?response_type=${responseType}&client_id=${clientId}&scope=${scopes}&redirect_uri=${redirectUri}&nonce=${nonce}&state=${state}`;

    window.location.href = loginUrl;

}

export const openLogoutUrl = () => {
    //document.getElementById('modalWindowOpen').style.display = 'block';
    window.location.href = configuration.urlLogin + 'logout?post_logout_redirect_uri=' + configuration.baseUrlWeb;
}

export const openKbaPage = () => {
    
    console.debug('Abrindo página do KBA');
    
    var redirect_uri = encodeURIComponent(encodeURIComponent(encodeURIComponent(configuration.baseUrlWeb + "?logoutGovbr=true")));
    var prefixoUrlKba = configuration.kbaUrl;
    var sufixAccessToken = "?token=" + localStorage.getItem('ifs_auth');
    var sufixRedirect = "&uri_retorno="+ redirect_uri;
    var enderecoNovaJanela = prefixoUrlKba + sufixAccessToken + sufixRedirect;

    window.location.href = enderecoNovaJanela;
}

export const showPdfLocal = (res, assetRes,fileName) =>{
    getInternalResource(res)
    .then(response => (criarDownloadPdfImpl(response.data, fileName)))
    .catch();
}

export const oldServicesUrl = () => {
    return './v35/index.html#';
}

export const getDevicePlatform = () => {
    return 'Web';
}

export const getVersion = () => {}

export const update = () => {}

export const exit = () => {
    window.close();
}

export const logoutIfWithoutBiometric = callback => {}

export const requestCameraPermission = (sucess, error) => {
    // TODO Falta verificar
    sucess();
}
